import React,{useState} from 'react';
import DeluxRoomPage from '../components/DeluxRoom';
import Footer from '../components/Footer';

// import Navbar2 from '../components/Navbar2';
import Navbar from '../components/Navbar';

import Sidebar from '../components/Sidebar';


function DeluxRoom() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <div>
            <Sidebar isOpen={isOpen} toggle={toggle} />
            <Navbar toggle={toggle} />  
           <DeluxRoomPage />
           <Footer />
        </div>
    )
}

export default DeluxRoom
